// extracted by mini-css-extract-plugin
export default {"top":"Fixed_top__-8Nyu","bottom":"Fixed_bottom__T0tvE","left":"Fixed_left__GQUu3","right":"Fixed_right__m-JKv"};